<template>
    <div>
        <slot :upgradeUrl="upgradeUrl"
              :continueUrl="resolvedContinueUrl"
              :isContinuePossible="isContinuePossible"
              :fields="fields"
        />
    </div>
</template>

<script>
export default {
    name: 'UpgradeMembershipForm',

    props: {
        upgradeUrl: {type: String, required: false, default: null},
        continueUrl: {type: String, required: false, default: null},
        popup: {type: Object, required: false},
    },

    data() {
        return {
            fields: {
                upgrade: true,
                cams: true,
                xsell: 1,
            }
        };
    },

    computed: {
        popupContinueUrl() {
            return this.popup?.params?.continueUrl;
        },

        resolvedContinueUrl() {
            return this.popupContinueUrl || this.continueUrl;
        },

        // If the continue link is the same as the upgrade link then we don't need to show a continue checkbox at all
        isContinuePossible() {
            return this.resolvedContinueUrl && this.resolvedContinueUrl !== this.upgradeUrl;
        },
    },
}
</script>
